import { Subscription } from 'rxjs';

export class SubscriptionsManager {

    private subscriptions: Subscription[] = [];

    set add(subscription: Subscription) {
        this.subscriptions.push(subscription);
    }

    unsubscribeAll() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

}
